import React, { useEffect, useState, createContext } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
export const I18nContext = createContext({
  language: 'en',
  setLanguage: (lang: string) => {}
});
export const I18nProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [language, setLanguage] = useState(i18n.language || 'en');
  useEffect(() => {
    // Listen for language changes
    const handleLanguageChanged = (lng: string) => {
      setLanguage(lng);
      document.documentElement.lang = lng;
      // For debugging
      console.log(`Language changed in I18nProvider: ${lng}`);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);
  return <I18nContext.Provider value={{
    language,
    setLanguage: lng => i18n.changeLanguage(lng)
  }} data-id="element-2822">
      <I18nextProvider i18n={i18n} data-id="element-2823">{children}</I18nextProvider>
    </I18nContext.Provider>;
};